.LabelContainer {
  flex: 1;
  min-width: 0;

  .Icon {
    flex-shrink: 0;
  }

  .Label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
